import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import { translate } from "react-i18next"
import { ENVIRONMENT } from "../../../constants"

function BackToTalentToolboxLink({
  className, extraClassNames, t, userDetails,
}) {
  const ttUrl = ENVIRONMENT.getTalentToolboxUrl(userDetails.client.subdomain)

  return (
    <a href={ttUrl} className={`${className} ${extraClassNames}`}>
      {t("Footer.Links.BackToTT")}
    </a>
  )
}

function mapStateToProps(state) {
  return {
    userDetails: state.userDetail,
  }
}

BackToTalentToolboxLink.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line max-len
  extraClassNames: PropTypes.string, // Seperation needed when adding classnames along with styled components auto generated class names
  t: PropTypes.func.isRequired,
  userDetails: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
    culture: PropTypes.string,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    client: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subdomain: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

BackToTalentToolboxLink.defaultProps = {
  className: "",
  extraClassNames: "",
}

export default compose(translate(), connect(mapStateToProps))(BackToTalentToolboxLink)



// WEBPACK FOOTER //
// ./src/components/layout/navigation/BackToTalentToolboxLink.jsx